import { ChannelResourceTypeDto } from "@api-types/chat";
import { AmityMessageMutated } from "@state/stores/chat/ChatChannelHandler";

export enum ChatEntryPoint {
	OFFER,
	SESSION,
	LIST,
	BET_SLIP_SHARE,
	SUPPORT,
	USER_MENU,
}

export enum ChatMessageType {
	REPLY = "reply",
	IMAGE = "image",
	VIDEO = "video",
	FILE = "file",
}

export enum ChatWindowState {
	OPENED = "opened",
	MINIMIZED = "minimized",
}

export enum ChatFlagState {
	FLAGGED = "flagged",
	UNFLAGGED = "unflagged",
}

export type ChannelInfoDataFromOffer = {
	channelType: ChannelResourceTypeDto;
	resourceId: string;
	sportAbrv?: string;
	categoryAbrv?: string;
	tournamentAbrv?: string;
};

export type ChannelInfoDataFromList = {
	channelId: string;
	displayName: string;
	sportAbrv?: string;
	categoryAbrv?: string;
	tournamentAbrv?: string;
};

export type ChannelInfoDataFromSession = {
	channelId: string;
	chatState: ChatWindowState;
	shouldOpenOnRefresh: boolean;
};

export type ActiveSharedBetSlip = {
	id: string;
	eventCount: number;
	maxCoefficient: number;
	betSlipNumber: string;
	dateCreated: string;
	sportAbrv: string;
	firstEventName: string;
	hasBetBuilder: boolean;
	bettingAccountTypeId: string;
};

export type SelectedReplyOnMessage = {
	subChannelId: string;
	creatorId: string;
	messageId: string;
	parentId: string;
	dataType: string;
	data: {
		msg: string;
		text: string;
		sharedSlip: ActiveSharedBetSlip;
		replyingCreatorId: string;
		replyingMessage: string;
		messageType: string;
		betSlipData: ActiveSharedBetSlip;
	};
	metadata: {
		isLink: boolean;
		isMultiOffer: boolean;
	};
};

export type ReplyMessageType = {
	messageId: string;
	text: string;
	replyingCreatorId: string;
	replyingMessage: string;
	sharedSlip: ActiveSharedBetSlip | null;
	isLink: boolean;
	isMultiOffer: boolean;
};

export type ExpandedMessageObject = {
	parentId?: string;
	data: {
		text?: string;
		sharedSlip: ActiveSharedBetSlip;
		messageType: ChatMessageType.REPLY;
		replyingCreatorId: string;
		replyingMessage: string;
		betSlipData: ActiveSharedBetSlip;
	};
	metadata: {
		isLink?: boolean;
		isMultiOffer?: boolean;
	};
} & AmityMessageMutated &
	Amity.RawMessage;
